import { RouteRecordRaw } from 'vue-router';

import { ROLES } from '@/constants';
import BaseLayout from '@/layouts/base-layout.vue';
import { redirectLogged } from '@/router/middlewares/redirectLogged';
import { isProduction } from '@/utils/isProduction';

const SignUpMain = () => import(
  '@/_redesign/modules/Onboarding/pages/SignUp/SignUp.vue'
);
const SignUpPhoneVerification = () => import(
  '@/_redesign/modules/Onboarding/pages/SignUp/SignUpPhone.vue'
);

const SIGNUP_CHILDREN: RouteRecordRaw[] = [
  {
    path: '',
    name: 'sign-up-creds',
    component: SignUpMain,
    meta: {
      disableGuard: true,
      middleware: [redirectLogged],
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
          fetchProfile: false,
          onClose: () => {
            window.location.href = isProduction() ? 'https://amaiz.com' : '/';
          },
        },
      },
    },
  },
  {
    path: 'phone-verification',
    name: 'sign-up-phone-verification',
    component: SignUpPhoneVerification,
    meta: {
      permission: [
        ROLES.merchant_onboarding_1,
        ROLES.individual_onboarding_1,
        ROLES.sole_trader_onboarding_1,
      ],
      layout: {
        componentName: 'RedesignLayout',
        props: {
          isClosable: true,
          fetchProfile: false,
          onClose: () => {
            window.location.href = isProduction() ? 'https://amaiz.com' : '/';
          },
        },
      },
    },
  },
];

export const SIGNUP: RouteRecordRaw = {
  path: '/sign-up',
  name: 'sign-up',
  component: BaseLayout,
  props: {
    fetchProfile: false,
  },
  children: SIGNUP_CHILDREN,
  redirect: SIGNUP_CHILDREN[0],
};
